import { Route, Routes } from 'react-router-dom';
import { AuthLogin } from './login';
import { AuthCallback } from './callback';
import { Logout } from './log-out';

const Auth = () => {
  return (
    <Routes>
      <Route path='login' element={<AuthLogin />} />
      <Route path='callback' element={<AuthCallback />} />
      <Route path='logout' element={<Logout />} />
      <Route path='*' element={<AuthLogin />} />
    </Routes>
  );
};

export default Auth;
